/**
 * Class to handle the behaviour of context menus.
 */
export default class Context {
  constructor() {
    const contextItems = document.querySelectorAll('.context .context__btn');

    contextItems.forEach((item) => {
      item.addEventListener('click', this.toggle);
    });

    window.addEventListener('click', this.outsideClick);
  }

  /**
   * Handles the click on the context-menu button.
   * @param {Event} e
   */
  toggle(e) {
    const root = e.target.parentElement;

    if (root.classList.contains('open')) {
      root.classList.remove('open');
    } else {
      const current = document.querySelector('.context.open');

      if (current) {
        current.classList.remove('open');
      }

      root.classList.add('open');
    }
  }

  /**
   * Handles the outside click behaviour of context menus.
   * @param {Event} e
   */
  outsideClick(e) {
    const current = document.querySelector('.context.open');

    if (!current) {
      return;
    }

    if (!e.target.closest('.context.open')) {
      current.classList.remove('open');
    }
  }
}
